import { render } from "./ErrorMessages.vue?vue&type=template&id=15d8872e&scoped=true"
import script from "./ErrorMessages.vue?vue&type=script&lang=js"
export * from "./ErrorMessages.vue?vue&type=script&lang=js"

import "./ErrorMessages.vue?vue&type=style&index=0&id=15d8872e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mapalytics-frontend/mapalytics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d8872e"]])

export default __exports__